module.exports = "<div  [class]=\"currentTheme + ' container-fluid page-body'\">\r\n  <div class=\"row\">\r\n    <div class=\"col-12 header-section\">\r\n      <app-header></app-header>\r\n    </div>\r\n    <div class=\"col-12 content-section mt-5 mb-3 pt-4\"> \r\n      <router-outlet></router-outlet>\r\n    </div>\r\n    <app-footer></app-footer>\r\n  </div>\r\n</div>\r\n<app-preloader></app-preloader>"


//////////////////
// WEBPACK FOOTER
// C:/Users/sthanga1/Documents/apicloud-x/apicloud-x/apim-ui-newgen/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main